/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_SaveInputs */

const vi_grower_area_camera_save = /** @type {(inputs: Grower_Area_Camera_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu camera`)
};

/**

* @param {Grower_Area_Camera_SaveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_save = /** @type {((inputs?: Grower_Area_Camera_SaveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_SaveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_save(inputs)
});